// extracted by mini-css-extract-plugin
export default {"Container":"DeviceItemTable_Container__NY0EP","Wrapper":"DeviceItemTable_Wrapper__yMTIT","Text":"DeviceItemTable_Text__Ce-k6"};